import { render, staticRenderFns } from "./DataSet.vue?vue&type=template&id=6e5b3808&scoped=true"
import script from "./DataSet.vue?vue&type=script&lang=js"
export * from "./DataSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5b3808",
  null
  
)

export default component.exports